import serialFieldConfig from './serialFieldConfig'
import ticketTypes from './ticketTypes'
import noteTypes from './noteTypes'
import roles from './roles'

/**
 * Schenck's application settings
 */
export default {
  languages: ['en', 'de'],
  namespaces: [
    'admin',
    'team',
    'ticket',
  ],
  // List of mail domains that are banned from registration
  bannedMailDomains: [
    'schenck', // banning all TLDs that contain 'schenck'
  ],
  suppressPersistence: true,
  wideLayoutLogin: true,
  secondaryColorLogin: true,
  forceExtendedRegistration: true,
  swapDeviceSerialAndName: true,
  serialImage: 'Serial.png',
  serialFieldConfig,
  suppressProductDocumentation: true,
  suppressEquipmentOptions: true,
  suppressProductDevices: true,
  suppressTicketFinishStepForRoles: ['Sales', 'CustomerServiceCooperator'],
  showTicketInternalStep: true,
  teamDefaultRoles: ['Sales', 'CustomerServiceAgent'],
  suppressExternalTeams: true,
  suppressSoftwareInfo: true,
  suppressFieldServiceInfo: true,
  registerRequestTypesDropdown: true,
  skipVerificationOnApproval: true,
  ticketTypes,
  noteTypes,
  roles,
}
